export const EGYPT_GOVERNORATES = [
  { value: 'القاهرة', label: 'القاهرة' },
  { value: 'الجيزة', label: 'الجيزة' },
  { value: 'الإسكندرية', label: 'الإسكندرية' },
  { value: 'القليوبية', label: 'القليوبية' },
  { value: 'المنوفية', label: 'المنوفية' },
  { value: 'الغربية', label: 'الغربية' },
  { value: 'كفر الشيخ', label: 'كفر الشيخ' },
  { value: 'الدقهلية', label: 'الدقهلية' },
  { value: 'دمياط', label: 'دمياط' },
  { value: 'الشرقية', label: 'الشرقية' },
  { value: 'بورسعيد', label: 'بورسعيد' },
  { value: 'الإسماعيلية', label: 'الإسماعيلية' },
  { value: 'السويس', label: 'السويس' },
  { value: 'البحيرة', label: 'البحيرة' },
  { value: 'مطروح', label: 'مطروح' },
  { value: 'شمال سيناء', label: 'شمال سيناء' },
  { value: 'جنوب سيناء', label: 'جنوب سيناء' },
  { value: 'بني سويف', label: 'بني سويف' },
  { value: 'الفيوم', label: 'الفيوم' },
  { value: 'المنيا', label: 'المنيا' },
  { value: 'أسيوط', label: 'أسيوط' },
  { value: 'سوهاج', label: 'سوهاج' },
  { value: 'قنا', label: 'قنا' },
  { value: 'الأقصر', label: 'الأقصر' },
  { value: 'أسوان', label: 'أسوان' },
  { value: 'البحر الأحمر', label: 'البحر الأحمر' },
  { value: 'الوادي الجديد', label: 'الوادي الجديد' },
];
